import React from 'react';
import PropTypes from 'prop-types';

import './technologies.styles.scss';

class TechnologiesSwitcher extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      closed: true
    };
  }

  toggle = () => {
    this.setState({ closed: !this.state.closed });
  };

  render() {
    let defaultEl = this.props.children[0];
    let defaultData = <div className='technologies-switcher-closed'>
      <div className='technologies-switcher-button'
         onClick={this.toggle}>{ this.props.technologiesMessage || 'Switch to technologies' }</div>

      {defaultEl}
    </div>;

    let technologiesEl = this.props.children[1];

    if (!technologiesEl) {
      return this.props.children;
    }

    let technologiesInfo = <div className='technologies-switcher-closed'>
      <div className='technologies-switcher-button'
         onClick={this.toggle}>{ this.props.skillsMessage || 'Switch to skills' }</div>

      {technologiesEl}
    </div>;

    return <div className='technologies-switcher'>
      {this.state.closed ? defaultData : technologiesInfo}
    </div>;
  }

}

TechnologiesSwitcher.propTypes = {
  technologiesMessage: PropTypes.string,
  skillsMessage: PropTypes.string
};

export default TechnologiesSwitcher;
